export enum RoleActions {
  EMPLOYEE = 'receive payments',
  MANAGER = 'issue payments, and receive payments',
  SITE_ADMIN = 'manage users, issue payments, and receive payments',
  ADMIN = 'manage users, issue payments, and receive payments',
}
